import React from "react";
import { ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import Routes from "routes";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
// import socket, { connectSocket } from "constants/SocketContant";
export const Views = () => {
  const { locale, direction } = useSelector((state) => state.theme);
  // const { profile } = useSelector((state) => state.auth);
  // const userId = profile?.id;

  // connect to socket
  // useEffect(() => {
  //   if (userId ) {
  //       if(!socket.connected)
  //       connectSocket(userId);
  //   }else {
  //     socket.disconnect()
  //   }
  // }, [userId]);

  const currentAppLocale = resources[locale];
  useBodyClass(`dir-${direction}`);
  return (
    <ConfigProvider direction={direction} locale={currentAppLocale.antd}>
      <Routes />
    </ConfigProvider>
  );
};

export default Views;
